module.exports = __webpack_public_path__ + "img/shili_02@3x.5af72b24.png";